<template>
  <div>
    <div class="header">
      카테고리
    </div>
    <category-inline-form
      v-for="category in itemList"
      :key="category.id"
      :mode="category.mode"
      :data="category"
      :is-active="category.id === activeCategoryId"
      @changeMode="handleChangeMode"
      @update="handleUpdateForm"
      @delete="handleDeleteForm"
      @select="handleSelectItem"
    />
    <category-inline-form
      v-if="isCreating"
      :mode="INLINE_FORM_MODE.FORM"
      @create="handleCreateForm"
      @changeMode="handleChangeMode"
    />
    <div
      class="category-item add"
      @click="isCreating = true"
    >
      <img
        class="folder-icon"
        src="/image/folder/add.png"
      >
      <span>카테고리 추가</span>
    </div>
  </div>
</template>

<script>
import CategoryInlineForm from './CategoryInlineForm';
import { INLINE_FORM_MODE } from '@/constants';
import { fiflboxApi } from '@/utils/api';

export default {
  name: 'CategoryList',
  components: { CategoryInlineForm },
  props: ['categoryType', 'activeCategoryId'],
  data() {
    return {
      INLINE_FORM_MODE,
      isCreating: false,
      itemList: []
    };
  },
  computed: {
    apiResourcePath() {
      return `/admin/${this.categoryType}/categories/`;
    }
  },
  watch: {
    activeCategoryId(value) {
      let activeItem = this.itemList.find(item => item.id === value);
      this.$emit('selectCategory', activeItem.name);
    }
  },
  async mounted() {
    await this.syncCategoryData();
  },
  methods: {
    async syncCategoryData() {
      try {
        let { data: categories } = await fiflboxApi.v2.getCourseCategories({
          is_removed: false
        });

        this.itemList = categories.map(data => {
          return {
            mode: INLINE_FORM_MODE.VIEW,
            ...data
          };
        });

        if (this.activeCategoryId) {
          this.$emit('update:activeCategoryId', this.activeCategoryId);
        } else {
          this.$emit('update:activeCategoryId', this.itemList[0].id);
        }

        let activeItem = this.itemList.find(
          item => item.id === this.activeCategoryId
        );
        this.$emit('selectCategory', activeItem.name);
      } catch (err) {}
    },
    async handleChangeMode(_data) {
      if (_data.id === null) {
        return (this.isCreating = false);
      }

      this.itemList.find(data => data.id === _data.id).mode = _data.mode;
    },
    async handleUpdateForm(form) {
      try {
        await fiflboxApi.v1.putCourseCategories(form.id, form);
        await this.syncCategoryData();
      } catch (err) {}
    },
    async handleCreateForm(form) {
      try {
        this.isCreating = false;
        await fiflboxApi.v1.postCourseCategoriesc(form);
        await this.syncCategoryData();
        this.isCreating = false;
      } catch (err) {}
    },
    async handleDeleteForm(form) {
      this.$emit('delete', {
        form,
        categories: this.itemList
      });
    },
    handleSelectItem({ id }) {
      this.itemList = this.itemList.map(item => {
        item.mode = INLINE_FORM_MODE.VIEW;
        return item;
      });

      this.$emit('update:activeCategoryId', id);
    }
  }
};
</script>

<style lang="scss">
.category-item {
  height: 40px;
  border-radius: 6px;
  padding: 10px 10px 10px 40px;
  box-sizing: border-box;
  margin-bottom: 2px;
  position: relative;
  color: #4a4a4a;
  display: flex;

  &.add {
    margin-top: 20px;

    span {
      color: #9b9b9b;
    }
  }

  &.view:hover,
  &.add:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }

  &.active {
    background-color: #9b9b9b;
    color: #ffffff;

    &:hover {
      background-color: #919191;
      cursor: pointer;
    }
  }

  input {
    flex: 1;
    height: 20px;
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: -0.8px;
    background-color: transparent;
    border: 0;

    @media screen and (max-width: 768px) {
      width: calc(100% - 70px);
    }
  }

  input::placeholder {
    color: #d3d3d3;
  }

  input:focus {
    outline: none;
  }

  .folder-icon {
    position: absolute;
    top: 5px;
    left: 5px;
    width: 30px;
  }

  span {
    display: inline-block;
    line-height: 20px;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: -0.8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
  }
}
</style>
